import { ISwiperCarouselArrowsProps } from '../SwiperCarousel';
export const createArrows = () => {
  const uniqueId = Math.random().toString(16).slice(-4);
  const prevEl = `arrow-prev-${uniqueId}`;
  const nextEl = `arrow-next-${uniqueId}`;
  const arrows = {
    prevEl: `#${prevEl}`,
    nextEl: `#${nextEl}`
  };
  return {
    prevEl,
    nextEl,
    arrows
  };
};